<form [formGroup]="addressForm">
  <div class="modal-switch">
    <div class="form-group text-start">
      <label for="street">{{"address.address" | translate}}:</label>
      <input type="text" class="form-control mb-3" name="street" id="street" formControlName="street" maxlength="150">
    </div>
    <div class="row">
      <div class="form-group col-md-6 text-start">
        <label for="postalCode">{{"address.zip" | translate}}:</label>
        <input type="text" class="form-control mb-3" name="postalCode" id="postalCode" formControlName="postalCode" maxlength="10" inputmode="numeric" pattern="[\d-]*" oninput="this.value = this.value.replace(/[^0-9\-]/g, '');">
        <label for="district">{{"address.state" | translate}}:</label>
        <input type="text" class="form-control mb-3" name="district" id="district" formControlName="district" maxlength="40">
      </div>
      <div class="form-group col-md-6 text-start">
        <label for="city">{{"address.city" | translate}}:</label>
        <input type="text" class="form-control mb-3" name="city" id="city" formControlName="city" maxlength="85">
        <label for="country">{{"address.country" | translate}}:</label>
        <input type="text" class="form-control mb-3" name="country" id="country" formControlName="country" maxlength="44">
      </div>
    </div>
  </div>
</form>
